import { render, staticRenderFns } from "./RichTextBlock.vue?vue&type=template&id=6cbc8513&scoped=true&"
import script from "./RichTextBlock.vue?vue&type=script&lang=js&"
export * from "./RichTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./RichTextBlock.vue?vue&type=style&index=0&id=6cbc8513&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc8513",
  null
  
)

export default component.exports